import React from "react";

export default function ML_Recognition() {
  return (
    <div>
      <h1>ML_Recognition</h1>
      <p>This is the ML_Recognition component.</p>
    </div>
  );
}
